import React from "react";

import Text from "@sats-group/ui-lib/react/text";

import type { PaymentSummary as Props } from "./payment-summary.props";

const PaymentSummary: React.FunctionComponent<Props> = ({
  description,
  partials,
  total,
}) => (
  <div className="payment-summary">
    <div className="payment-summary__line">
      <Text size={Text.sizes.interface} theme={Text.themes.emphasis}>
        {description}
      </Text>
    </div>
    <hr className="payment-summary__divider" />
    {partials.map(({ label, value }) => (
      <div key={label} className="payment-summary__line">
        <Text size={Text.sizes.interface}>{label}</Text>
        <Text size={Text.sizes.interface}>{value}</Text>
      </div>
    ))}
    <div className="payment-summary__line">
      <Text size={Text.sizes.interface} theme={Text.themes.emphasis}>
        {total.label}
      </Text>
      <Text size={Text.sizes.interface} theme={Text.themes.emphasis}>
        {total.value}
      </Text>
    </div>
  </div>
);

export default PaymentSummary;
